import React, { useEffect, useRef, useState } from 'react'
import ContainerLayout from '../../../components/container-layout/ContainerLayout'
import { useTranslation } from 'react-i18next';
import NavigateListCustom from '../../../components/navigation/NavigationListCustom';
import { routeName } from '../../../routes/routeName';
import { Box, Grid, IconButton, Typography } from '@mui/material';
import CheckBoxCustom from '../../../components/checkbox/CheckBoxCustom';
import ContainerButton from '../../../components/button/ContainerButton';
import StateComponents from '../../../components/state-component/StateComponents';
import { handleTypingNumber } from '../../../utils/app.utils';
import { NavigateFunction, useNavigate, useParams } from 'react-router-dom';
import { setLoading, unsetLoading } from '../../../store/loading/loading.slice';
import { PaymentChannelsApi } from '../../../api/payment-channels/payment-channels.api';
import { alertError, alertSuccess, swalError } from '../../../components/alert/swal';
import { useDispatch } from 'react-redux';
import { bankListArray } from '../../cms/course-online/manage-payment-channel/enum/manage_payment';
import { ButtonContained } from '../../../components/button/ButtonCustoms';
import CancelIcon from '@mui/icons-material/Cancel';

export default function ManagePaymentDetail(props: any) {
    const { view } = props
    const { t, i18n } = useTranslation();
    const fileRef = useRef<any>()
    const [pathUrl, setPathUrl] = useState<string>("");
    const { id } = useParams()
    const dispatch = useDispatch();
    const navigate: NavigateFunction = useNavigate();

    const [file, set_file] = useState<any>();
    const [form, setForm] = useState<any>()
    useEffect(() => {
        const init = async () => {
            const response = await fetch("/resources/config.json");
            const results = await response.json();
            setPathUrl(results?.REACT_APP_BASE_API_PUBLIC || "");
        };
        init();
    }, []);

    const onImageChange = async (event: any) => {
        if (event.target.files && event.target.files[0]) {
            const formData = new FormData();

            //DRAFT
            formData.append('file', event.target.files[0]);

            await PaymentChannelsApi.uploadPaymentChannelFile(formData).then((res: any) => {
                if (res.status < 300) {
                    setForm({ ...form, id_file: res.data.data?.id_payment_channels_file, payment_channels_file: res.data.data })
                    if (fileRef.current) {
                        fileRef.current.value = null;
                    }
                    // swalSuccess('ยืนยันการชำระเงิน', 'ยืนยันการชำระเงิน เรียบร้อยแล้ว กรูณารอทางเจ้าหน้าที่ตรวจสอบ')
                }
            }).catch((error: any) => {
                console.log(error)
                if (fileRef.current) {
                    fileRef.current.value = null;
                }
                swalError(error?.response?.data?.message || t('เกิดข้อผิดพลาด'))
            })

        }
    }

    const getDetail = async () => {

        await PaymentChannelsApi.getOne(Number(id)).then((res) => {
            if (res.status < 300) {
                setForm({
                    ...res.data.data, select_bank: {
                        fullname: res.data.data?.bank_name_th,
                        nameEN: res.data.data?.bank_name_eng,
                    }
                })
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
        })
    }
    useEffect(() => {
        if (id) {
            getDetail()
        }

    }, [])

    const handleSubmit = async () => {
        const body = {
            ...form,
            select_bank: undefined,
            application_fee: 0,
            term_fee: 0,
            file: undefined,
            bank_name_th: form?.select_bank?.fullname,
            bank_name_eng: form?.select_bank?.nameEN,
        }
        dispatch(setLoading());
        if (id) {
            await PaymentChannelsApi.updatePaymentChannel(Number(id), body)
                .then((res) => {
                    if (res.status < 300) {
                        alertSuccess(t("MANAGE_PAYMENT_EDIT"), t("MANAGE_PAYMENT_EDIT_COMPLETED"), undefined, () => {
                            navigate(routeName.admission.ManagePayment)
                        });
                    }
                })
                .catch((err) => {
                    console.log(err);
                    alertError(t("MANAGE_PAYMENT_EDIT"), t("MANAGE_PAYMENT_EDIT_FAILED"));
                })
                .finally(() => {
                    dispatch(unsetLoading());
                });
        } else {
            await PaymentChannelsApi.createPaymentChannel(body)
                .then((res) => {
                    if (res.status < 300) {
                    
                          alertSuccess(t("MANAGE_PAYMENT_ADD_PAYMENT"), t("MANAGE_PAYMENT_ADD_PAYMENT_COMPLETED"), undefined, () => {
                            navigate(routeName.admission.ManagePayment)
                        });
                    }
                })
                .catch((err) => {
                    console.log(err);
                    alertError(t("MANAGE_PAYMENT_ADD_PAYMENT"), t("MANAGE_PAYMENT_ADD_PAYMENT_FAILED"));
                })
                .finally(() => {
                    dispatch(unsetLoading());
                });
        }

    }
    return (
        <div className='w-full'>
            <ContainerLayout
                title={t("MANAGE_PAYMENT_DETAILS")}
                navigateContent={
                    <NavigateListCustom
                        navigateData={[
                            {
                                key: "complaintSubmit",
                                name: t("MANAGE_PAYMENT"),
                                disabled_match: true,
                                pathName: routeName.admission.ManagePayment
                            },
                            {
                                key: "complaintSubmit",
                                name: t("MANAGE_PAYMENT_DETAILS"),
                                pathName: routeName.admission.ManagePayment
                            },

                        ]}
                    />
                }
                content={
                    <div className='w-full'>
                        <Grid container spacing={2}>
                            <Grid item md={3}>
                                <StateComponents
                                    otherProps={{ spacing: 2 }}
                                    typeProps={[

                                        {
                                            seq: 1,
                                            type: "SELECT",
                                            gridProps: {
                                                xs: 12,
                                            },
                                            fieldProps: {
                                                labelId: "ss",
                                                heading: t("MANAGE_PAYMENT_TYPE"),
                                                onChange: (e) => {
                                                    setForm({ ...form, payment_channels_type: e.target.value })
                                                    // handleChange('form_type', index, e.target.value);
                                                },
                                                options: [
                                                    {
                                                        label: "PAYMENT_TERM",
                                                        value: 'PAYMENT_TERM',
                                                    },
                                                    {
                                                        label: "PAYMENT_MEETING_ROOM",
                                                        value: 'PAYMENT_MEETING_ROOM',
                                                    },
                                                    {
                                                        label: "ONLINE_COURSE",
                                                        value: 'ONLINE_COURSE',
                                                    },

                                                ],
                                                selectId: "",
                                                value: form?.payment_channels_type || '',
                                                disabled: view
                                            }
                                        },
                                        {
                                            seq: 2,
                                            type: "AUTO-COMPLETE",
                                            gridProps: {
                                                xs: 12
                                            },
                                            fieldProps: {
                                                getOptionLabel: (op) => (i18n.language === "en" ? op?.nameEN || op?.fullname : op?.fullname),
                                                labelId: "bank",
                                                heading: t("MANAGE_PAYMENT_BANK"),
                                                placeholder: t("MANAGE_PAYMENT_BANK"),
                                                onChange: (_, val) => setForm({ ...form, select_bank: val }),
                                                options: bankListArray || [],
                                                value: form?.select_bank || null,
                                                disabled: view
                                            }
                                        },
                                    ]}
                                />
                                {/* <div style={{ display: "flex", justifyContent: "center", marginTop: '20px' }}>
                                    <div style={{
                                        width: "100%",
                                        height: "350px",
                                        borderRadius: '20px',
                                        border: '5px solid #fff',
                                        boxShadow: 'rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px',
                                        // marginTop: "-100px",
                                        background: '#fff',
                                        cursor: 'pointer',
                                        overflow: 'hidden'
                                    }} onClick={() => uploadRef?.current?.click()}>
                                        <img src={file ? URL.createObjectURL(file) : id ? pathUrl + '/' + (form?.employee_file?.file_path?.includes('employee') ? form?.employee_file?.file_path + form?.employee_file?.file_name : form?.employee_file?.file_path) : 'https://placehold.co/600x400?text=No+Img'} style={{ width: '100%', height: "100%", objectFit: 'cover', objectPosition: 'center' }} />
                                    </div>
                                    <input type='file' accept="image/png, image/jpeg" ref={uploadRef} onChange={(obj: any) => set_file(obj.target.files[0])} style={{ display: 'none' }} />

                                </div> */}
                                {/* {form?.select_bank && (
                                    <div className='w-full h-fit flex justify-center bg-[#DDE1EB] mt-4 rounded-xl items-center px-4 py-10'>
                                        <img src={form?.select_bank?.icon} alt={form?.select_bank?.symbol} />
                                    </div>
                                )} */}
                                <Box sx={{
                                    boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
                                    padding: "10px",
                                    borderRadius: "20px",
                                    height: "300px",
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: "center",
                                    justifyContent: "center",
                                    position: 'relative',
                                    marginTop: '15px'
                                }} >
                                    {form?.payment_channels_file ?
                                        <img src={pathUrl + '/' + form?.payment_channels_file?.file_path + form?.payment_channels_file?.file_name} /> :
                                        <>
                                            <ButtonContained buttonName='Choose Image' onClick={() => fileRef.current.click()} />
                                        </>
                                    }
                                    <input ref={fileRef} className='hidden' type='file'
                                        accept={"image/*"}
                                        onChange={(e: any) => onImageChange(e)} />
                                    {form?.payment_channels_file &&
                                        <IconButton sx={{ position: "absolute", top: '20px', right: '20px' }} onClick={() => {
                                            setForm({ ...form, id_file: '', file: undefined })
                                        }}><CancelIcon sx={{ color: "#e7e7e7" }} /></IconButton>}
                                </Box>
                            </Grid>
                            <Grid item md={9}>
                                <Typography>{t('MANAGE_PAYMENT_USAGE_TYPE')}</Typography>
                                <CheckBoxCustom disabled={view} label={t('MANAGE_PAYMENT_APPLICATION_FEE')} checked={form?.register_fees || ''} setChecked={(e) => setForm({ ...form, register_fees: e })} />
                                <CheckBoxCustom disabled={view} label={t('MANAGE_PAYMENT_TUITION_FEE')} checked={form?.term_fees || ''} setChecked={(e) => setForm({ ...form, term_fees: e })} />

                                <StateComponents
                                    otherProps={{ spacing: 2 }}
                                    disabledAllField={view}
                                    typeProps={[
                                        {
                                            seq: 1,
                                            type: "TEXT_FIELD",
                                            gridProps: {
                                                xs: 12,
                                            },
                                            fieldProps: {
                                                heading: t("MANAGE_PAYMENT_PAYMENT_NAME"),
                                                value: form?.payment_channels_name || '',
                                                onChange: (e) => { setForm({ ...form, payment_channels_name: e.target.value }) }
                                            },
                                        },
                                        // {
                                        //     seq: 2,
                                        //     type: "SELECT",
                                        //     gridProps: {
                                        //         xs: 12,
                                        //         md: 6
                                        //     },
                                        //     fieldProps: {
                                        //         labelId: "ss",
                                        //         heading: "ระดับ",
                                        //         onChange: (e) => {
                                        //             // handleChange('form_type', index, e.target.value);
                                        //         },
                                        //         options: [
                                        //             {
                                        //                 label: "THB",
                                        //                 value: 'THB',
                                        //             },

                                        //         ],
                                        //         selectId: "",
                                        //         value: ''
                                        //     }
                                        // },
                                        // {
                                        //     seq: 3,
                                        //     type: "SELECT",
                                        //     gridProps: {
                                        //         xs: 12,
                                        //         md: 6
                                        //     },
                                        //     fieldProps: {
                                        //         labelId: "ss",
                                        //         heading: "คณะ",
                                        //         onChange: (e) => {
                                        //             // handleChange('form_type', index, e.target.value);
                                        //         },
                                        //         options: [
                                        //             {
                                        //                 label: "THB",
                                        //                 value: 'THB',
                                        //             },

                                        //         ],
                                        //         selectId: "",
                                        //         value: ''
                                        //     }
                                        // },
                                        {
                                            seq: 4,
                                            type: "TEXT_FIELD",
                                            gridProps: {
                                                xs: 12,
                                                md: 6
                                            },
                                            fieldProps: {
                                                heading: t("MANAGE_PAYMENT_ACCOUNT_NAME_TH"),
                                                value: form?.account_name_th || '',
                                                onChange: (e) => { setForm({ ...form, account_name_th: e.target.value }) }
                                            }
                                        },
                                        {
                                            seq: 5,
                                            type: "TEXT_FIELD",
                                            gridProps: {
                                                xs: 12,
                                                md: 6
                                            },
                                            fieldProps: {
                                                heading: t("MANAGE_PAYMENT_ACCOUNT_NAME_EN"),
                                                value: form?.account_name_eng || '',
                                                onChange: (e) => { setForm({ ...form, account_name_eng: e.target.value }) }
                                            }
                                        },
                                        {
                                            seq: 6,
                                            type: "TEXT_FIELD",
                                            gridProps: {
                                                xs: 12,
                                                md: 6
                                            },
                                            fieldProps: {
                                                heading: t("MANAGE_PAYMENT_ACCOUNT_NUMBER"),
                                                value: form?.account_no || '',
                                                onChange: (e) => { setForm({ ...form, account_no: e.target.value }) },
                                                onkeypress: handleTypingNumber
                                            }
                                        },
                                        {
                                            seq: 7,
                                            type: "SELECT",
                                            gridProps: {
                                                xs: 12,
                                                md: 6
                                            },
                                            fieldProps: {
                                                labelId: "ss",
                                                heading: t("MANAGE_PAYMENT_ACCOUNT_TYPE"),
                                                onChange: (e) => {
                                                    // handleChange('form_type', index, e.target.value);
                                                    setForm({ ...form, account_type: e.target.value })
                                                },
                                                options: [
                                                    {
                                                        label: "SAVINGS",
                                                        value: 'SAVINGS',
                                                    },
                                                    {
                                                        label: "CURRENT",
                                                        value: 'CURRENT',
                                                    },
                                                    {
                                                        label: "FIXED_DEPOSIT",
                                                        value: 'FIXED_DEPOSIT',
                                                    },
                                                    {
                                                        label: "SPECIAL_DEPOSIT",
                                                        value: 'SPECIAL_DEPOSIT',
                                                    },
                                                    {
                                                        label: "INVESTMENT",
                                                        value: 'INVESTMENT',
                                                    },
                                                    {
                                                        label: "FOREIGN_CURRENCY_DEPOSIT",
                                                        value: 'FOREIGN_CURRENCY_DEPOSIT',
                                                    },
                                                    {
                                                        label: "BASIC",
                                                        value: 'BASIC',
                                                    },

                                                ],
                                                selectId: "",
                                                value: form?.account_type || ''
                                            }
                                        },
                                    ]}
                                />
                            </Grid>
                        </Grid>
                        <ContainerButton
                            sxContainer={{ my: 3 }}
                            buttonData={[
                                {
                                    seq: 1,
                                    buttonProps: {
                                        onClick: () => {
                                            navigate(routeName.admission.ManagePayment)
                                        },
                                    },
                                    key: "CANCEL",
                                    label: t("MANAGE_PAYMENT_BACK"),
                                    type: "CANCEL"
                                },

                                {
                                    seq: 2,
                                    buttonProps: {
                                        onClick: () => {
                                            handleSubmit()
                                        }
                                    },
                                    hidden: view,
                                    key: "SEND",
                                    label: t("MANAGE_PAYMENT_CONFIRM"),
                                    type: 'SAVE'
                                },

                            ]}
                        />
                    </div>}
            />
        </div>
    )
}
